import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { persistFinancingFromQuote, } from '../../../api/requests';
import Button from '../../../components/form-control/Button';
import Loader from '../../../components/Loader';
import useRoute from '../../../hooks/routesHook';
import useUserAccount from '../../../hooks/userAccountHook';
import { Insurer } from '../../../models/insurer/Insurer';
import { useSelector } from 'react-redux';
import { getSelectedCountry } from '../../../states/slices/resourceSlice';
import { ISaveQuoteDTO } from '../../../resources/interfaces';
import { useQuery } from '@tanstack/react-query';
import { showToast } from '../../../utils/miscFunctions';

const AdminCreatePremiumFinancingApplication = () => {
  const { user } = useUserAccount();
  const [searchParams, setSearchParams] = useSearchParams();
  const [processing, setProcessing] = useState<boolean>(true);
  const navigate = useNavigate();
  const { getDashboardBase } = useRoute();
  const selectedCountry = useSelector(getSelectedCountry);
  const country = selectedCountry?.iso ?? 'GH'
  const loadingMessage = 'Just a sec. Processing...';
  const [insurer, setInsurer] = useState<Insurer>();
  const countryId = searchParams.get('countryId') ?? 1;
  const [persistFinancingReponse, setPersistFinancingReponse] = useState<any>()


  const persistFinancingCreation = () => {

    if (searchParams) {
      const quoteData: ISaveQuoteDTO = {
        cc: Number(searchParams.get('cc') ?? 0),
        email: searchParams.get('email') ?? '',
        excess: Number(searchParams.get('excess') ?? 0),
        initialDeposit: Number(searchParams.get('initialDeposit') ?? 0),
        installmentType: searchParams.get('installmentType') ?? '',
        insurer: user.isInsurer() ? undefined : Number(searchParams.get('insurer') ?? undefined),
        insurerId: user.isInsurer() ? undefined : Number(searchParams.get('insurer') ?? undefined),
        manufacturedYear: Number(searchParams.get('manufacturedYear') ?? 0),
        monthlyInstallment: Number(searchParams.get('monthlyInstallment') ?? 0),
        numOfPassenger: Number(searchParams.get('numOfPassenger') ?? 0),
        outRightPremium: Number(searchParams.get('outRightPremium') ?? 0),
        phone: searchParams.get('phone') ?? '',
        protectionType: searchParams.get('protectionType') ?? '',
        registrationYear: Number(searchParams.get('registrationYear') ?? 0),
        totalInterest: Number(searchParams.get('totalInterest') ?? 0),
        totalPremium: Number(searchParams.get('totalPremium') ?? 0),
        vehicleInsuredValue: Number(searchParams.get('vehicleInsuredValue') ?? 0),
        vehicleModel: searchParams.get('vehicleModel') ?? '',
        vehicleUse: searchParams.get('vehicleUse') ?? '',
        firstName: searchParams.get('firstName') ?? '',
        lastName: searchParams.get('lastName') ?? '',
        source: searchParams.get('source') ?? '',
        period: Number(searchParams.get('period') ?? 0),
        startsOn: '',
        countryId: Number(countryId)
      };

      persistFinancing(quoteData)
    }
  }

  useQuery({ queryKey: ['persistFinancingCreation'], queryFn: persistFinancingCreation })

  const persistFinancing = (quoteData: ISaveQuoteDTO) => {
    persistFinancingFromQuote(quoteData)
      .then((response: any) => {

        setPersistFinancingReponse(response.data);
        setProcessing(false)

      })
      .catch((error: any) => {
        showToast.error(error.description || 'Something went wrong');

        navigate(`${getDashboardBase()}/premium-financing`, { replace: true });
      })
      .finally(() => {

      })
  };

  return (
    <div className="flex items-center flex-col py-6 text-dark ">
      <>
        <div className="flex flex-col justify-center items-center absolute inset-0 z-[1000] bg-black/40 backdrop-blur-md">
          {!processing ? (
            <>
              <h3 className="font-semibold font-poppins w-full text-center py-6 z-10 text-white text-[30px]">
                Great job! <br />
                Complete the required information and submit for review.
              </h3>
              <Button
                label="Proceed"
                className="bg-primary-main rounded-[8px] border-none font-poppins px-8 !font-bold"
                onClick={() =>
                  persistFinancingReponse && navigate(`${getDashboardBase()}/premium-financing/${persistFinancingReponse.applicationNumber}/edit`, { replace: true })
                }
              />
            </>
          ) : (
            <>
              <Loader
                message={loadingMessage}
                size="md"
                messageClasses="!text-white"
                classes="z-[10]"
              />
              <h3 className="font-semibold font-poppins w-full text-center py-6 z-[10] text-white text-[30px]">
                A moment <br /> Application is being created...
              </h3>
            </>
          )}
        </div>
      </>
    </div>
  );
};

export default AdminCreatePremiumFinancingApplication;
